module.exports = __webpack_public_path__ + "static/media/tratoflix.7af921fd.png";